import React, { useState } from 'react'
import { IoMdClose } from 'react-icons/io';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 2,
        slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 768 },
        items: 2,
        slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 767, min: 320 },
        items: 2,
        slidesToSlide: 1 // optional, default to 1.
    }
};

function CarouselTwoImageSlider({ images, bgColor, txtColor, btnColor, btnTxtColor }) {

    const [readMore, setReadMore] = useState(false);
    const [detailView, setDetailView] = useState(false);

    const handleReadMore = (item) => {
        setReadMore(!readMore);
        setDetailView(item)
    };

    const handleClose = () => {
        setReadMore(false);
        setDetailView("")
    };

    return (
        <div>
            <Carousel
                responsive={responsive}
                autoPlay={true}
                swipeable={false}
                draggable={false}
                showDots={false}
                infinite={true}
                partialVisible={false}
                dotListClass="custom-dot-list-style"
                className='z-40'
            >
                {images?.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className="flex flex-col items-center mt-2  "
                        >
                            <img className="rounded-xs w-40 h-40 cursor-pointer object-cover" src={item.image} alt="" onClick={(e) => handleReadMore(item)} />

                        </div>
                    );
                })}
            </Carousel>

            {readMore &&
                <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none overflow-x-hidden overflow-y-auto   ">
                    <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-filter backdrop-blur-sm"></div>
                    <div className="relative w-auto my-6 mx-auto max-w-3xl rounded-xl ">
                        <div
                            className="w-[330px] h-[500px]  rounded-xl flex  justify-center pt-5  inset-0 z-50 outline-none focus:outline-none"
                            id="modal"
                            style={{
                                color: txtColor,
                                backgroundColor: bgColor,
                            }}
                        >

                            <div>

                                <div className=' flex m-3 '>
                                    <p className="text-base font-semibold  w-5/6">
                                        {detailView?.headline}
                                    </p>
                                    <button
                                        style={{
                                            backgroundColor: btnColor,
                                            color: btnTxtColor,
                                        }}
                                        className="cursor-pointer  mr-3 w-10 h-10 rounded-full flex justify-center items-center"
                                        onClick={handleClose}
                                    >
                                        <IoMdClose />
                                    </button>
                                </div>
                                <div className="m-3 w-[300px] h-[380px] overflow-auto scrollbar-hide">

                                    <img src={detailView?.image} alt="Modal Content" className="w-full" />
                                    <p className="font-base text-sm mt-4">
                                        {detailView?.description}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default CarouselTwoImageSlider